// GrazeBoxes/SectionTitle.jsx
import React from "react";
import { Typography } from "@mui/material";

const SectionTitle = ({ text, align = "center", sx = {} }) => {
  return (
    <Typography
      variant="h4"
      fontWeight="bold"
      textAlign={align}
      sx={{
        fontFamily: "Moul",
        mb: 4,
        ...sx,
      }}>
      {text}
    </Typography>
  );
};

export default SectionTitle;
